import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import BaremetalDetails from "components/baremetal/manage/BaremetalDetails";
import IconSelector from "components/shared/images/IconSelector";

const BaremetalDetailsPage = (): ReactElement => {
 return (
  <Paper elevation={1} sx={{ borderRadius: "5px" }}>
   <Stack p={2} spacing={2}>
    <Stack direction="row" spacing={1}>
     <IconSelector icon="DetailsIcon" props={{ fontSize: "medium", color: "kxOrange" }} />
     <Typography fontSize={16} ml={1} variant="unboundedTitle">
      <FormattedMessage id="baremetal.details" />
     </Typography>
    </Stack>
   </Stack>
   <Stack p={2} pt={0}>
    <BaremetalDetails />
   </Stack>
  </Paper>
 );
};

export default BaremetalDetailsPage;
